export default '/build/808659bc.svg'